import { systemEngineEnvironment } from "services/environment/systemEngine";

export const getDatabaseDefinitions = (database: {
  catalogName: string;
  description: string;
}) => {
  const descriptionSql = database.description
    ? systemEngineEnvironment.formatter.formatQuery("\nWITH DESCRIPTION = ?", [
        database.description,
      ])
    : "";

  const createDatabaseSql =
    `CREATE DATABASE "${database.catalogName}"` + descriptionSql + ";";
  return createDatabaseSql;
};

export const createWorkspaceDatabase = async (database: {
  catalogName: string;
  description: string;
}) => {
  const sql = getDatabaseDefinitions(database);
  await systemEngineEnvironment.execute(sql);
};
